import classNames from 'classnames';
import { useMemo, useState } from 'react';
import Player from 'react-player';
// import { classNames } from 'react-select/src/utils';
import { TemplateClassNames } from '../../../../../../types/template-layouts';
import { HomepageVideo } from '../../../../../../types/working-model';
import { Button } from '../../../../../general-ui/button/button';
import Icon, { COLORS, ICONS } from '../../../../../general-ui/icon';
import { EIcon } from '../../../../../general-ui/icon/icon';
import '../../../../../live-event/modules/video/video.scss';

interface Props {
	video: HomepageVideo;
	multi?: boolean;
	editVideo: (video: HomepageVideo) => void;
	checkDeleteVideo: (video: HomepageVideo) => void;
	template: TemplateClassNames
}

export default function Video(props: Props): JSX.Element {
	const { video, editVideo, checkDeleteVideo, template } = props;

	const [showVid, setShowVid] = useState(false);
	const [playing, setPlaying] = useState(false);

	function revealVideo() {
		setShowVid(true);
	}

	const showControls = useMemo(() => {
		return video.source?.endsWith('.mp4') || video.hls_link;
	}, [video]);

	return (
		<div className={classNames("video-preview", template)}>
			{showVid || !video.use_thumbnail ? (
				<>
					{video.source && (
						<>
							<Player
								url={video.hls_link ? video.hls_link : video.source}
								height="100%"
								width="100%"
								playing={playing}
								style={{ background: '#000' }}
							/>
							{showControls && (
								<div className="player-controls">
									<Button
										classButton={classNames('play-button primary')}
										template={template}
										onClick={() => setPlaying(!playing)}
									>
										{
											playing
												? <EIcon name="pause" size="medium" />
												: <EIcon name="play" size="medium" />
										}
									</Button>
								</div>
							)}
						</>
					)}
				</>
			) : (
				<div
					style={{ backgroundImage: `url(${video.image})` }}
					className="video-poster"
				>
					<Button
						classButton={classNames('play-button primary')}
						template={template}
						onClick={revealVideo}
					>
						<EIcon name="play" size="medium" />
					</Button>
				</div>
			)}
			<div className="edit-actions-wrapper">
				<button className="round edit-button" onClick={() => editVideo(video)}>
					<Icon name={ICONS.EDIT} size={12} color={COLORS.WHITE} />
				</button>
				<button
					className="round edit-button"
					onClick={() => checkDeleteVideo(video)}
				>
					<Icon name={ICONS.TRASH} size={12} color={COLORS.WHITE} />
				</button>
			</div>
		</div>
	);
}
